import { call, put } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  fetchOfferVoucherInfoSuccess,
  fetchOfferVoucherInfoFailure,
} from '../actions/campaignOfferInfo';

const { getOfferInfo } = api;

export default function* (offerReference, session, getVouchers, voucherCode) {
  try {
    const offerVoucherInfo = yield call(getOfferInfo, offerReference, session, getVouchers);

    const findVoucher = offerVoucherInfo.find(api => api.voucherCode.toUpperCase() === voucherCode.toUpperCase());

    if (!findVoucher) {
      throw new Error(`The Voucher code ${voucherCode} is invalid for offer ${offerReference}`);
    }

    if (findVoucher.status.toLowerCase() !== 'new') {
      throw new Error(`The voucher code ${voucherCode} is not active for offer ${offerReference}`);
    }

    yield put(fetchOfferVoucherInfoSuccess(offerVoucherInfo));
    return offerVoucherInfo;
  } catch (error) {
    console.error(error); // eslint-disable-line
    yield put(fetchOfferVoucherInfoFailure(error));
    return null;
  }
}
